import React, { Fragment, useEffect, useState } from 'react'
import CMContainer from './CM/CMContainer'
// import MoreSequencesQuest from './CM/MoreSequencesQuest'

const CM = ({
    sequences,
    editMode,
    setNextStep,
    changeContext,
    createSequence,
    changeResources,
    handleChangeAttribute,
    handleChangeAttributeUnitValue,
    handleDeleteAttribute,
    loadingDelete,
    handleReplacesResources,
    sessionId,
    onChangeInterludes,
    displayContextCM,
    handleChangeSequencesResourcesCM
}) => {

    const [sequencesNumber, setSequencesNumber] = useState(0)

    useEffect(() => {
        if (sequences && sequences.length > 0) {
            setSequencesNumber(sequences.length)
        } else {
            setSequencesNumber(1)
            createSequence()
        }
        // eslint-disable-next-line
    }, [createSequence])


    return (
        <Fragment>
            {sequencesNumber > 0 &&
                <CMContainer
                    editMode={editMode}
                    number={1}
                    changeContext={changeContext}
                    sequence={sequences[0]}
                    changeResources={changeResources}
                    resources={(sequences[0] && sequences[0].resources) ? sequences[0].resources : []}
                    attributes={sequences[0].attributes}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    loadingDelete={loadingDelete}
                    handleReplacesResources={handleReplacesResources}
                    sessionId={sessionId}
                    interludes={sequences[0].intro ? sequences[0].intro : []}
                    onChangeInterludes={onChangeInterludes}
                    displayContextCM={displayContextCM}
                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                />
            }
            {sequences[0] && sequences[0].sequenceContext &&
                <CMContainer
                    editMode={editMode}
                    number={2}
                    createSequence={createSequence}
                    changeContext={changeContext}
                    sequence={sequences[1]}
                    changeResources={changeResources}
                    resources={(sequences[1] && sequences[1].resources) ? sequences[1].resources : []}
                    attributes={sequences[1] && sequences[1].attributes ? sequences[1].attributes : []}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    loadingDelete={loadingDelete}
                    handleReplacesResources={handleReplacesResources}
                    sessionId={sessionId}
                    interludes={sequences[1] && sequences[1].intro ? sequences[1].intro : []}
                    onChangeInterludes={onChangeInterludes}
                    displayContextCM={displayContextCM}
                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                />
            }
            {sequences[1] && sequences[1].sequenceContext &&
                <CMContainer
                    editMode={editMode}
                    number={3}
                    createSequence={createSequence}
                    changeContext={changeContext}
                    sequence={sequences[2]}
                    changeResources={changeResources}
                    resources={(sequences[2] && sequences[2].resources) ? sequences[2].resources : []}
                    attributes={sequences[2] && sequences[2].attributes ? sequences[2].attributes : []}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    loadingDelete={loadingDelete}
                    handleReplacesResources={handleReplacesResources}
                    sessionId={sessionId}
                    interludes={sequences[2] && sequences[2].intro ? sequences[2].intro : []}
                    onChangeInterludes={onChangeInterludes}
                    displayContextCM={displayContextCM}
                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                />
            }
            {sequences[2] && sequences[2].sequenceContext &&
                <CMContainer
                    editMode={editMode}
                    number={4}
                    createSequence={createSequence}
                    changeContext={changeContext}
                    sequence={sequences[3]}
                    changeResources={changeResources}
                    resources={(sequences[3] && sequences[3].resources) ? sequences[3].resources : []}
                    attributes={sequences[3] && sequences[3].attributes ? sequences[3].attributes : []}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    loadingDelete={loadingDelete}
                    handleReplacesResources={handleReplacesResources}
                    sessionId={sessionId}
                    interludes={sequences[3] && sequences[3].intro ? sequences[2].intro : []}
                    onChangeInterludes={onChangeInterludes}
                    displayContextCM={displayContextCM}
                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                />
            }
            {sequences[3] && sequences[3].sequenceContext &&
                <CMContainer
                    editMode={editMode}
                    number={5}
                    createSequence={createSequence}
                    changeContext={changeContext}
                    sequence={sequences[4]}
                    changeResources={changeResources}
                    resources={(sequences[4] && sequences[4].resources) ? sequences[4].resources : []}
                    attributes={sequences[4] && sequences[4].attributes ? sequences[4].attributes : []}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    loadingDelete={loadingDelete}
                    handleReplacesResources={handleReplacesResources}
                    sessionId={sessionId}
                    interludes={sequences[4] && sequences[4].intro ? sequences[2].intro : []}
                    onChangeInterludes={onChangeInterludes}
                    displayContextCM={displayContextCM}
                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                />
            }
            {sequences[4] && sequences[4].sequenceContext &&
                <CMContainer
                    editMode={editMode}
                    number={6}
                    createSequence={createSequence}
                    changeContext={changeContext}
                    sequence={sequences[5]}
                    changeResources={changeResources}
                    resources={(sequences[5] && sequences[5].resources) ? sequences[5].resources : []}
                    attributes={sequences[5] && sequences[5].attributes ? sequences[5].attributes : []}
                    handleChangeAttribute={handleChangeAttribute}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleDeleteAttribute={handleDeleteAttribute}
                    loadingDelete={loadingDelete}
                    handleReplacesResources={handleReplacesResources}
                    sessionId={sessionId}
                    interludes={sequences[5] && sequences[5].intro ? sequences[2].intro : []}
                    onChangeInterludes={onChangeInterludes}
                    displayContextCM={displayContextCM}
                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                />
            }


        </Fragment>
    )
}


export default CM
